// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "startfoco-8e527.firebaseapp.com",
  "projectId": "startfoco-8e527",
  "storageBucket": "startfoco-8e527.firebasestorage.app",
  "messagingSenderId": "323254623605",
  "appId": "1:323254623605:web:5ade896b54890c83c7c73c",
  "measurementId": "G-J4VMKPN2V9",
  "apiKey": "AIzaSyBGpX696HXWeyh-K-pA2zRz6bEtHkVDZYc"
};
